// hooks/usePrefetchAdjacentArticles.ts

import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import i18n from "../localization/i18n";
import { fetchFullArticleDetails } from "../services/apiService";
import { useUserStore } from "../store/userStore";
import { queryClient } from "../services/tanStackClient";

const staleTime = 60 * 60 * 1000;

export function usePrefetchAdjacentArticles(
  nextArticleId?: string | null,
  previousArticleId?: string | null
) {
  const { user } = useUserStore();
  const language = i18n.language;

  useEffect(() => {
    const uid = user?.firebaseUser?.uid;
    if (!uid) return;

    const prefetch = (articleId?: string | null) => {
      if (!articleId) return;

      const key = ["article-details", articleId, language, uid];

      // avoid duplicate prefetch
      if (queryClient.getQueryData(key)) return;

      queryClient.prefetchQuery({
        queryKey: key,
        queryFn: () => fetchFullArticleDetails(articleId),
        staleTime,
      });
    };

    prefetch(nextArticleId);
    prefetch(previousArticleId);

  }, [nextArticleId, previousArticleId, language, user?.firebaseUser?.uid]);
}